module.exports = __webpack_public_path__ + "img/success.e6b59c03.png";